import { render, staticRenderFns } from "./Boletos.vue?vue&type=template&id=2cb958e4"
import script from "./Boletos.vue?vue&type=script&lang=ts"
export * from "./Boletos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports